export const scheduleNonCriticalStartup = (init, options = {}) => {
    const { timeoutMs = 2000 } = options;
    let hasRun = false;
    const run = () => {
        if (hasRun) {
            return;
        }
        hasRun = true;
        init();
    };
    window.addEventListener('pointerdown', run, { passive: true, once: true });
    window.addEventListener('keydown', run, { once: true });
    window.addEventListener('touchstart', run, { passive: true, once: true });
    window.addEventListener('scroll', run, { passive: true, once: true });
    window.addEventListener('load', run, { once: true });
    window.setTimeout(run, timeoutMs);
};
